import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, SearchIcon, BellIcon, BookmarkIcon, BarChart2Icon, SettingsIcon, HelpCircleIcon, LogOutIcon, XIcon, FolderIcon, UserIcon, GlobeIcon, ListIcon, ArrowLeftIcon } from 'lucide-react';
interface DashboardSidebarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}
export function DashboardSidebar({
  open,
  setOpen
}: DashboardSidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const navigation = [{
    name: "Page d'accueil",
    icon: ArrowLeftIcon,
    href: '/',
    current: currentPath === '/'
  }, {
    name: 'Tableau de bord',
    icon: HomeIcon,
    href: '/dashboard',
    current: currentPath === '/dashboard'
  }, {
    name: 'Recherche',
    icon: SearchIcon,
    href: '/recherche',
    current: currentPath === '/recherche'
  }, {
    name: "Tous les appels d'offres",
    icon: ListIcon,
    href: '/premium-tenders',
    current: currentPath === '/premium-tenders'
  }, {
    name: 'Mes alertes',
    icon: BellIcon,
    href: '/alertes',
    current: currentPath === '/alertes'
  }, {
    name: 'Favoris',
    icon: BookmarkIcon,
    href: '/favoris',
    current: currentPath === '/favoris'
  }, {
    name: 'Documents',
    icon: FolderIcon,
    href: '/documents',
    current: currentPath === '/documents'
  }, {
    name: 'Statistiques',
    icon: BarChart2Icon,
    href: '/statistiques',
    current: currentPath === '/statistiques'
  }];
  const secondaryNavigation = [{
    name: 'Mon profil',
    icon: UserIcon,
    href: '/profil',
    current: currentPath === '/profil'
  }, {
    name: 'Paramètres',
    icon: SettingsIcon,
    href: '/parametres',
    current: currentPath === '/parametres'
  }, {
    name: 'Aide',
    icon: HelpCircleIcon,
    href: '/aide',
    current: currentPath === '/aide'
  }];
  const handleLogout = () => {
    // Handle logout logic here
    navigate('/');
  };
  return <div className={`fixed inset-y-0 left-0 z-30 w-64 bg-blue-900 transform transition duration-300 ease-in-out ${open ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`} data-id="element-183">
      <div className="h-full flex flex-col" data-id="element-184">
        {/* Sidebar header */}
        <div className="flex items-center justify-between h-16 px-4 bg-blue-800" data-id="element-185">
          <div className="flex items-center" data-id="element-186">
            <Link to="/" className="relative" data-id="element-187">
              <span className="text-xl font-bold text-white" data-id="element-188">
                Elevate<span className="text-yellow-500" data-id="element-189">IT</span>
              </span>
              <span className="text-xs font-normal ml-0.5 text-blue-200" data-id="element-190">
                .fr
              </span>
              <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-191"></div>
            </Link>
          </div>
          <button type="button" className="md:hidden text-blue-200 hover:text-white" onClick={() => setOpen(false)} data-id="element-192">
            <XIcon size={20} data-id="element-193" />
          </button>
        </div>
        {/* Navigation */}
        <div className="flex-1 flex flex-col overflow-y-auto pt-5 pb-4" data-id="element-194">
          <nav className="flex-1 px-2 space-y-1" data-id="element-195">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`group flex items-center px-3 py-3 rounded-md text-sm font-medium ${item.current ? 'bg-blue-800 text-white' : 'text-blue-200 hover:bg-blue-800 hover:text-white'}`} onClick={() => setOpen(false)} data-id="element-196">
                <item.icon className={`mr-3 flex-shrink-0 h-5 w-5 ${item.current ? 'text-white' : 'text-blue-300 group-hover:text-white'}`} data-id="element-197" />
                {item.name}
              </Link>)}
          </nav>
          <div className="px-3 mt-6" data-id="element-198">
            <div className="h-px bg-blue-800" data-id="element-199"></div>
            <nav className="mt-6 space-y-1" data-id="element-200">
              {secondaryNavigation.map(item => <Link key={item.name} to={item.href} className="group flex items-center px-3 py-2 rounded-md text-sm font-medium text-blue-200 hover:bg-blue-800 hover:text-white" onClick={() => setOpen(false)} data-id="element-201">
                  <item.icon className="mr-3 flex-shrink-0 h-5 w-5 text-blue-300 group-hover:text-white" data-id="element-202" />
                  {item.name}
                </Link>)}
            </nav>
          </div>
          {/* Subscription status */}
          <div className="px-3 mt-6" data-id="element-203">
            <div className="bg-blue-800 rounded-lg p-3" data-id="element-204">
              <div className="flex items-center" data-id="element-205">
                <GlobeIcon size={18} className="text-yellow-500 mr-2" data-id="element-206" />
                <span className="text-sm font-medium text-white" data-id="element-207">
                  Essai Gratuit
                </span>
              </div>
              <div className="mt-2 text-xs text-blue-200" data-id="element-208">
                Expire dans 7 jours
              </div>
              <div className="mt-2" data-id="element-209">
                <div className="h-1.5 bg-blue-700 rounded-full overflow-hidden" data-id="element-210">
                  <div className="bg-yellow-500 h-full" style={{
                  width: '30%'
                }} data-id="element-211"></div>
                </div>
              </div>
              <Link to="/upgrade" className="mt-3 block text-center text-xs font-medium text-white bg-yellow-500 hover:bg-yellow-400 py-2 px-3 rounded-md" data-id="element-212">
                Passer au Premium
              </Link>
            </div>
          </div>
        </div>
        {/* Logout */}
        <div className="p-3" data-id="element-213">
          <button onClick={handleLogout} className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-blue-200 hover:bg-blue-800 hover:text-white w-full text-left" data-id="element-214">
            <LogOutIcon className="mr-3 h-5 w-5" data-id="element-215" />
            Déconnexion
          </button>
        </div>
      </div>
    </div>;
}